import React from 'react';

interface Props {
  color?: string;
}

export const Star = ({ color = '#E2E2E2' }: Props) => {
  return (
    <svg aria-hidden width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.7545 1.47494C16.3162 -0.441889 19.0315 -0.441889 19.5931 1.47494L22.0796 9.96096C22.3293 10.8131 23.111 11.3986 23.9989 11.3986H32.4512C34.3383 11.3986 35.1755 13.7721 33.706 14.956L26.5243 20.742C25.8946 21.2493 25.6324 22.0858 25.8597 22.8618L28.5173 31.9316C29.0681 33.8112 26.8685 35.2802 25.3432 34.0514L18.9286 28.8834C18.1961 28.2933 17.1515 28.2933 16.4191 28.8834L10.0044 34.0514C8.47919 35.2802 6.2796 33.8112 6.83035 31.9316L9.48791 22.8618C9.71528 22.0859 9.45303 21.2493 8.82336 20.742L1.64166 14.956C0.172143 13.7721 1.00931 11.3986 2.89642 11.3986H11.3487C12.2367 11.3986 13.0183 10.8131 13.268 9.96096L15.7545 1.47494Z"
        fill={color}
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/Star.tsx